import { ISagaModule } from 'redux-dynamic-modules-saga'

import lawyerChatReducer from './reducers'
import lawyerChatSaga from './sagas'

export function getMessagesModule(): ISagaModule<{ lawyerChat }> {
  return {
    id: 'messages',
    reducerMap: {
      lawyerChat: lawyerChatReducer
    },
    sagas: [lawyerChatSaga]
  }
}
